

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

function setCookie(cname, cvalue, exdays) {
    var expires = "expires=0";
    if (exdays !== 0) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        expires = "expires=" + d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function showPanel() {
    $("body").css('overflow-y', 'scroll');
    $('.page-load').fadeOut();
}

function showHomePopup() {
    var popup = getCookie("showHomePopup");
    if (popup === "") {
        $('.page-load').removeClass('d-none');
        $('.page-content').removeClass('d-none');
        $('body').css('overflow', 'hidden');
        setCookie('showHomePopup', true, 1);
        setTimeout(showPanel, 5000)
    } else {
        $('.page-content').removeClass('d-none');
    }
}

$(document).click(function() {
    setTimeout(function(){
        if($('.full-menu').hasClass('menu--open')) {
            $('body').css('overflow', 'hidden');
            $('body').css('overflow-x', 'hidden');
            if(window.innerWidth < 540){
                $('.full-menu').css('overflow-y', 'scroll');
            }

        } else {
            $('body').css('overflow-y', 'scroll');
        }
    },100);
});

$(function () {

    if ($('.page-load').length > 0) {
        showHomePopup();
    }

    AOS.init({
        once: true,
        disable: function() {
            var maxWidth = 768;
            return window.innerWidth < maxWidth;
        }
    });


    var vid = $('#OrchardVideo');
    $(".play-btn").click(function() {
        if (vid[0].paused) {
            vid[0].play();
            $(this).find('.fa-pause').toggleClass('d-none');
            $(this).find('.fa-play').toggleClass('d-none');
        } else {
            vid[0].pause();
            $(this).find('.fa-play').toggleClass('d-none');
            $(this).find('.fa-pause').toggleClass('d-none');
        }
    });

    $(".sound-btn").click(function() {
        if(vid.prop('muted')) {
            vid.prop('muted', false);
            $(this).find('.fa-volume-up').toggleClass('d-none');
            $(this).find('.fa-volume-mute').toggleClass('d-none');
        } else {
            vid.prop('muted', true);
            $(this).find('.fa-volume-up').toggleClass('d-none');
            $(this).find('.fa-volume-mute').toggleClass('d-none');
        }
    });

    // to top
    var offset = 300,
        offset_opacity = 1200,
        scroll_top_duration = 700,
        $back_to_top = $('.to-top');

    $(window).scroll(function(){
        ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('to-is-visible') : $back_to_top.removeClass('to-is-visible cd-fade-out');
        if( $(this).scrollTop() > offset_opacity ) {
            $back_to_top.addClass('cd-fade-out');
        }
    });

    $back_to_top.on('click', function(event){
        event.preventDefault();
        $('body,html').animate({
                scrollTop: 0 ,
            }, scroll_top_duration
        );
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    var burger = $('.menu-btn');
    var menu = $('.full-menu');
    var navItems =$('.nav__item');
    burger.click(function(){
        burger.toggleClass('btn--open');
        menu.toggleClass('menu--open');
    });
    navItems.hover(function(){
        navItems.not($(this)).toggleClass('nav__item--hover');
    });

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

});

function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}
